import { render, staticRenderFns } from "./ReportResourceConfig.vue?vue&type=template&id=36bec3ca&scoped=true"
import script from "./ReportResourceConfig.vue?vue&type=script&lang=js"
export * from "./ReportResourceConfig.vue?vue&type=script&lang=js"
import style0 from "./ReportResourceConfig.vue?vue&type=style&index=0&id=36bec3ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bec3ca",
  null
  
)

export default component.exports